const info = 
{
    title: "The Present",
    type: "Script"
};

export default info;